import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';

import { BaryModalForm } from '../../../../../../../../models/bary-modal-form';
import { BaryComponentHelper } from '../../../../../../util/bary-component-helper';
import { IBaryModalEvent } from '../../../../../../../../models/bary-modal-event';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { EventManager } from '../../../../../../../../services/event-manager.service';

import dayjs from 'dayjs';

import { LIST_MAILTO } from '../../../../../../components/bary-mailto/bary-mailto.component';
import { SalesSupportActionsService } from '../../../../../../../../services/sales-support-actions.service';
import { forkJoin } from 'rxjs';
import { TransportView } from '../../../../../../../../models/transport-view.model';
import { CurrentDataService } from '../../../../../../../../services/current-data-service';
import { TypeSalesSupportActions } from '../../../../../../../../models/enums/types-sales-support-actions.enum';
import { ISalesSupportActions } from '../../../../../../../../models/sales-support-actions.model';
import { IHistory } from '../../../../../../../../models/history.model';

@Component({
  templateUrl: './popin-contact-transport.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopinContactTransportComponent extends BaryModalForm implements OnInit, OnDestroy {
  public override action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  public transportView!: TransportView;
  public commercialId?: number;
  public commercialFullName?: string;
  public LIST_MAILTO = LIST_MAILTO;
  public options: { label: string; value: any }[] = [];
  public controls = {
    confirmedPhone: new FormControl(false, []),
    confirmedMail: new FormControl(false, []),
  };

  constructor(
    public modalRef: MDBModalRef,
    protected eventManager: EventManager,
    private fb: FormBuilder,
    private salesSupportActionsService: SalesSupportActionsService,
    private currentDataService: CurrentDataService
  ) {
    super();
  }

  public handleClick(event: IBaryModalEvent): void {
    this.action.next(event);
    this.modalRef.hide();
  }

  ngOnInit(): void {
    this.controls = { confirmedPhone: this.fb.control(false, []), confirmedMail: this.fb.control(false, []) };
    this.modalForm = this.fb.group(this.controls);

    this.options.push({ label: 'appel effectué', value: false });
    this.options.push({ label: 'mail envoyé', value: false });

    this.currentDataService.getCustomer().subscribe(customer => (this.commercialId = customer?.id));
    this.currentDataService.getUser().subscribe(user => (this.commercialFullName = `${user?.firstName} ${user?.lastName}`));
  }

  public override handleSubmit(): void {
    const savesHttp = [];
    if (this.controls.confirmedPhone.value) {
      savesHttp.push(this.salesSupportActionsService.post(this.createSalesSupportActions(false)));
    }

    if (this.controls.confirmedMail.value) {
      savesHttp.push(this.salesSupportActionsService.post(this.createSalesSupportActions(true)));
    }

    forkJoin(savesHttp).subscribe((salesActions: ISalesSupportActions[]) => {
      const submitEvent = this.SUBMIT;
      submitEvent.value = salesActions;
      this.action.next(submitEvent);
      this.modalRef.hide();
    });
  }

  private createSalesSupportActions(isMailRemind: boolean): IHistory {
    return {
      typeSalesSupportActionsEnum: isMailRemind ? TypeSalesSupportActions.MAIL_REMINDER : TypeSalesSupportActions.PHONE_REMINDER,
      commercialId: this.commercialId,
      transportId: this.transportView.id,
      value: '{"date" : "' + dayjs().format('DD-MM-YYYY') + '" , "commercialId" : "' + this.commercialId + '" , "commercialFullName" : "' + this.commercialFullName + '"}',
    } as ISalesSupportActions;
  }

  public confirmedMailAfterGenerateEmail(): void {
    this.controls.confirmedMail.setValue(true);
  }
}
